import clsx from "clsx";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { impossible } from "../../../app/Utils";
import { RequirementsPanel } from "../../urs/RequirementsPanel";
import { selectDocument } from "../documentSlice";
import { LoadRequirements, LoadRequirementsTypes } from "../../../app/AppDataLoader";
import { LoadingContainer } from "../../../app/LoadingContainer";
import { useEffect, useState } from "react";
import { AsyncThunk } from "@reduxjs/toolkit";
import { dispatchURSChanged, loadUrs, Urs, useUrsState } from "../../urs/UrsSlice";
import { APIError, AppId, AppThunkAPIType } from "../../../app/appTypes";
import { showError } from "../../notifications/notificationsSlice";
import { Skeleton } from "@mui/material";
import { ServerErrorMsg } from "../../../app/ServerErrorMsg";

type Loader = AsyncThunk<Urs, AppId, AppThunkAPIType>
const LoadComponent = () => <Skeleton variant="rectangular" height="50vh" />


export interface RequirementsSectionProps {
    sectionId: string
}

export const RequirementsSection = (props: RequirementsSectionProps) => {
    return <LoadRequirementsTypes component={<LoadingContainer />}>
        <LoadRequirements component={<LoadingContainer />}>
            <RequirementsSectionInternal {...props} />
        </LoadRequirements>
    </LoadRequirementsTypes>
}


export const RequirementsSectionInternal = (props: RequirementsSectionProps) => {
    const { sectionId } = props
    const { header } = useAppSelector(selectDocument)?.doc ?? impossible()
    const { id } = header
    const dispatch = useAppDispatch()
    const load: Loader = loadUrs
    const [data, setData] = useState<Urs | 'error' | null>(null)
    const [err, setErr] = useState<APIError | null>(null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const loadedData = await dispatch(load(id)).unwrap()
                setData(loadedData)

                if (data !== null && data !== 'error') {
                    dispatchURSChanged(loadedData)
                }
            } catch (err) {
                if (typeof err === 'object' && err !== null && err['name'] && err['name'] === 'ConditionError') {
                    // action cancelled
                } else {
                    dispatch(showError("error"))
                    setErr(err as APIError)

                }
                setData('error')
            }
        }
        fetchData()
    }, [id])



    if (data === null) return <LoadComponent />

    if (data === 'error') return <ServerErrorMsg err={err} />



    return (
        <>
            <Form entity={data} />
        </>
    );


};

interface FormProps {
    entity: Urs
}


export const Form = (props: FormProps) => {
    const { entity: initialEntity, } = props

    const entity = useUrsState(initialEntity)

    return (
        <>
            <div className="flex flex-row gap-4">
                <div className={clsx('basis-full')}>
                    <RequirementsPanel
                        template={false}
                        urs={entity}
                    />
                </div>
                {/* {entity.isTemplate === false &&
                    <div className={clsx(commentsOpen ? 'basis-1/4' : 'basis-8', 'mt-9')}>
                        <Paper className="p-2">
                            <IconButton className={clsx({ 'hidden': !commentsOpen })} onClick={() => setCommentsOpen(false)}><ChevronRightIcon /></IconButton>
                            <IconButton className={clsx({ 'hidden': commentsOpen })} onClick={() => setCommentsOpen(true)}><ChevronLeftIcon /></IconButton>
                            <Divider className={clsx(commentsOpen ? '' : 'hidden', 'mb-2')} />
                            <If condition={!template && commentsOpen}>
                                {comments && <Comments
                                    comments={comments}
                                    ursId={entity.id}
                                    requirement={null}
                                    isCommentEnabled={userCanSendComment}
                                    isResolvingEnabled={userCanApproveComment}
                                    isEditEnabled={userCanEditComment}
                                />}
                            </If>
                        </Paper>
                    </div>
                } */}
            </div>
        </>
    )
}